export const TAGS_ROUTING = [
  {
    path: '/text/tags/:tag',
    name: 'tag',
    component: () => import(/* webpackChunkName: "tag-page" */ './pages/tag.page')
  }
];
